import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { setAutoCheckedIn } from '../../action/autoCheckin';
import { setGoHome } from '../../action/homeAction';
import { mobileCheckinColorConfig } from '../../JS/colorConfig'
import { sendConfidenceScore } from '../../action/autoCheckin';
import { withTranslation } from 'react-i18next'
import { popupOpenClose, setPreCheckInWidgetState } from "../../../action/action";
import { AesUtil } from "../../../JS/AesUtil";
import { CMSPath, DONT_ASK_BOOKING_NUMBER_ON_PRECHECKIN_SUCCESS, globalIV, globalSalt } from "../../../config/constant";
import { formatTime, toBool } from "../../JS/utility";
import checkPreCheckinWidgetState from "../home/checkPreCheckInWidgetState";
import { getServerTime } from "../../../action/homeAction";
import Loader from "../../UI/loader";

const PreCheckInSuccess = (props) => {

    const { t } = props
    let aesUtil = new AesUtil(128, 1000);
    const [bookingNumber, setBookingNumber] = React.useState("");
    const [guestName, setGuestName] = React.useState("");
    const checkinStartTime = formatTime(new Date(`2000-01-01T${props.checkInStartTime}Z`), toBool(props.timeFormat))
    const earlyCheckInStartTime = formatTime(new Date(`2000-01-01T${props.earlyCheckInStartTime}Z`), toBool(props.timeFormat))
    const [checkPreCheckInWidgetStateVar, setCheckPreCheckInWidgetStateVar] = React.useState(null);
    const [showLoader, setShowLoader] = React.useState(false);
    const [verbiage, setVerbiage]= useState("");


    const handleCheckInNow = () => {

        if(DONT_ASK_BOOKING_NUMBER_ON_PRECHECKIN_SUCCESS || localStorage.getItem("X_CHECKIN_PQ_DATA")){
            props.proceed();
        } else {

            if(!bookingNumber || bookingNumber == ""){
                props.popupOpenClose(true, "Please enter a valid booking number");
                return;
            }

            if(bookingNumber != props.bookingNumber){
                props.popupOpenClose(true, t('pre_checkIn.error_matching_booking_number'));
                return;
            }

            props.proceed();
        }
    }

    useEffect(()=>{

       const verbiage= (props && props.proceedToCheckIn ?

            (checkPreCheckInWidgetStateVar == "pre check-in" || checkPreCheckInWidgetStateVar == "early check-in")

            ?  
                (props.userCompletedCheckInFlow ?
                 t('pre_checkIn.preCheckIn_success_now_cannotCheckIn_checkInDay')
                  : t('pre_checkIn.preCheckIn_success_before_cannotCheckIn_CheckInDay'))
    
            : 
                ( props.userCompletedCheckInFlow ?
                 t('pre_checkIn.preCheckIn_success_now_canCheckIn')
                  : t('pre_checkIn.preCheckIn_success_before_canCheckIn'))
            
            :  
                (props.userCompletedCheckInFlow ? t('pre_checkIn.preCheckIn_success_now_cannotCheckIn')
                 : t('pre_checkIn.preCheckIn_success_before_cannotCheckIn')));


        setVerbiage(verbiage.replace("#GUESTNAME",guestName).replace("#checkInStartTime", checkinStartTime).replace("#earlyCheckInStartTime", earlyCheckInStartTime));
        

    },[props.proceedToCheckIn, checkPreCheckInWidgetStateVar, checkPreCheckInWidgetStateVar, props.userCompletedCheckInFlow, guestName, checkinStartTime, earlyCheckInStartTime ])

    React.useEffect(() => {
        window.scrollTo(0, 0);
        mobileCheckinColorConfig(props.menuColor);

        if (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
            const preCheckInDoneInfo = localStorage.getItem("X_CHECKIN_PQ_DATA") ? JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA"))) : JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",sessionStorage.getItem("X_CHECKIN_PQ_DATA")));            

            if(preCheckInDoneInfo && preCheckInDoneInfo.guestName){
                setGuestName(preCheckInDoneInfo.guestName);
            }
        }

        setShowLoader(true);

        props.getServerTime((status,payload) => {
            setShowLoader(false);

            if(status){
                setCheckPreCheckInWidgetStateVar(checkPreCheckinWidgetState(props, payload && payload.date))
            } else {
                setCheckPreCheckInWidgetStateVar(checkPreCheckinWidgetState(props))
            }
        })
    }, [])

    return !showLoader && checkPreCheckInWidgetStateVar ? (
        <>
            <div class="main-container pre-checkin-success" style={{background: "url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat", backgroundSize: "cover", backgroundAttachment: "fixed"}}>
                <header class="inner-pages w-footer subpages">
                    <a onClick={() => props.setGoHome(true)} className="button-back"></a>
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${props.logo}`} />
                        </div>
                        {/* <p class="bold">{ props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section class="widgets padding-0 margin-0 container-bg">

                    <div class="widget-header widget-header-checkin-inner precheckin-success">
                        { props.currentWidgetObj.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                    </div>

                    <div class="widgets">

                        { !process.env.REACT_APP_NEWER_DESIGN=="true" && <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                            { props.currentWidgetObj.widgetType == "Pre Check-in" && <h2>{t('pre_checkIn.success')}</h2>}
                        </div> }
                        
                        <div class="form-window">
                            <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <div class="form-row">
                                    <div class="progress-circle success over50 p100">
                                        <span>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 333.33 237.59"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M328.32,5h0a17.13,17.13,0,0,0-24.21,0l-191.5,191.5L29.22,113.13a17.13,17.13,0,0,0-24.21,0H5a17.13,17.13,0,0,0,0,24.21l95.25,95.25a17.74,17.74,0,0,0,24.69,0L328.32,29.22A17.13,17.13,0,0,0,328.32,5Z"></path></g></g></svg>
                                        </span>
                                        <div class="left-half-clipper">
                                            <div class="first50-bar"></div>
                                            <div class="value-bar"></div>
                                        </div>
                                    </div>
                                </div>

                              {  process.env.REACT_APP_NEWER_DESIGN=="true" && <div class ="header" dangerouslySetInnerHTML={{  __html : t('pre_checkIn.preCheckIn_complete')} }></div> }

                                <div class="form-row margin-top-2 margin-bottom-2">


                                <p style={{whiteSpace:"pre-line"}}>
                                    {verbiage}
                                </p>
                             

                                    { props && props.proceedToCheckIn && checkPreCheckInWidgetStateVar != "pre check-in" && !localStorage.getItem("X_CHECKIN_PQ_DATA") && !DONT_ASK_BOOKING_NUMBER_ON_PRECHECKIN_SUCCESS &&
                                        <><div class="enter-booking-number">

                                            <p>{t('pre_checkIn.enter_booking_number')}</p>

                                            <label for="bookingNum">{t('pre_checkIn.booking_number')}</label>
                                            <input name="bookingNum" id="bookingNum" type="text" value={bookingNumber} onChange={(e) => setBookingNumber(e.target.value)} />

                                        </div>
                                        </>
                                    }
                                </div>
                                {props && props.proceedToCheckIn && !props.mobileCheckInDisabled ?
                                    <div class="form-controls">
                                        <button disabled={props.checkinGuestLoading || checkPreCheckInWidgetStateVar == "pre check-in"} onClick={() => handleCheckInNow()} class="primary w-100">{t('pre_checkIn.checkin')}</button>
                                        <button disabled={props.checkinGuestLoading} onClick={() => props.setGoHome(true)} class="secondary w-100 margin-top-1">{t('pre_checkIn.later')}</button>
                                    </div>
                                    : <div className="form-controls">
                                        <button onClick={() => props.setGoHome(true)} className="primary w-100" >{t('pre_checkIn.close')}</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    ) : (
        <Loader displayMsg={"Please wait"} />
    )
}


const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        checkPreCheckInWidgetState: state.store2.checkPreCheckInWidgetState,
        serverTimeDate: state.store.home.serverTimeDate.date,
        mobileCheckInDisabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled) : false,
        preCheckInEnabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled) : false,
        checkInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.checkInStartTime,
        earlyCheckInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.earlyCheckInStartTime,
        timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM
    }
}


export default connect(mapStateToProps, {
    setAutoCheckedIn,
    setGoHome,
    getServerTime,
    popupOpenClose,
    setPreCheckInWidgetState,
    sendConfidenceScore
})(withTranslation('translations')(PreCheckInSuccess));